module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAbCAMAAACUTyX1AAAAUVBMVEUAAAD////8/Pz8/Pz7+/v////8/Pz8/Pz8/Pz7+/v7+/v////9/f38/Pz7+/v7+/v39/f+/v7+/v7+/v7+/v7+/v76+vr7+/v5+fn7+/v///94gn1JAAAAGnRSTlMA64RuOvOQd2ZVQfezX0ovEubc1czFmXxPJe6wGWwAAAB7SURBVBjTbZFXDsQgDEQhQOqW7KbP/Q+aYnCwlfl7DwnZY+PstJksAMI344Aj/uYZZ1rmHlc+LAoSDYuOxDuxA6VOwkbhIjeIqaL4J1EQt1DixYLYJ+we3z1jefEgcVW//+Q4tRo3yHUWuW6v6ihVXVbWaVTdprJjfo4d5VoS0RwDNrAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/re.png
// module id = RGn2
// module chunks = 1